import { THeadingTag, TImageField, TLinkField, TStringField } from '../../../types/types';
import { isEmptyObject } from '../../../utils/checkEmptyObject';
import { getFollowingHTag } from '../../../utils/seo.utils';
import { TSocialMediaBarProps } from '../../@shared/socialMediaBar/types/socialMediaBar.types';
import {
  TLatestNewsCardItemProps,
  TLatestNewsParams,
  TLatestNewsProps,
  TLatestNewsPropsFields,
  TLatestNewsPropsItemData,
} from '../types/latestNews.types';

export class LatestNewsModel {
  private readonly fields?: TLatestNewsPropsFields;
  private readonly itemData?: TLatestNewsPropsItemData;
  private readonly params?: TLatestNewsParams | null;

  constructor(props: TLatestNewsProps) {
    this.fields = props?.fields || null;
    this.itemData = props?.fields?.itemData;
    this.params = props?.params || null;
  }

  get title(): TStringField | undefined {
    return this.itemData?.fields?.title;
  }

  get eyebrow(): TStringField | undefined {
    return this.itemData?.fields?.eyebrow;
  }

  get baseUrl(): string {
    return this.itemData?.contextItemUrl || '';
  }

  get defaultCardImageNarrow(): TImageField | undefined {
    return this.fields?.itemData?.fields?.defaultCardImageNarrow;
  }

  get link(): TLinkField | undefined {
    return {
      value: {
        href: this.fields?.itemData?.fields?.newsMainPageLink?.value || '',
      },
    };
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h2';
  }

  get cardHeadingTitleTag(): THeadingTag {
    return getFollowingHTag(this.headingTag);
  }

  get items(): TLatestNewsCardItemProps[] {
    return this.fields?.apiData?.items || [];
  }

  get socialMediaBarProps(): TSocialMediaBarProps | undefined {
    return isEmptyObject(this.fields?.socialMediaBar) ? undefined : this.fields?.socialMediaBar;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
